import ApiInstance from '../../interfaces/api-instance';
import { getSessionTokenFromUrl } from '../../utilis/session-token';
import { SESSION_METADATA_ROUTES } from './route';

// Feeds the INPERFORMANCE_ACTION Mixpanel event, not the exercise
// flow itself — a failure here must never block or redirect a live session.
const getSessionMetadata = async sessionId => {
  const { data } = await ApiInstance.get(SESSION_METADATA_ROUTES.SESSION_METADATA(sessionId), {
    params: { session_token: getSessionTokenFromUrl() },
    skipAuthRedirect: true,
  });
  return data;
};

export const SessionMetadataApis = {
  getSessionMetadata,
};
